import { render } from "./Heading4.vue?vue&type=template&id=3c24d7c8&scoped=true&ts=true"
import script from "./Heading4.vue?vue&type=script&lang=ts"
export * from "./Heading4.vue?vue&type=script&lang=ts"

import "./Heading4.vue?vue&type=style&index=0&id=3c24d7c8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c24d7c8"]])

export default __exports__